module.exports = __webpack_public_path__ + "img/vehicle.d21fceed.svg";